import { useEffect } from "react";

import type { MapData } from "@map/mapiq-map-react/src/MapView";
import { getMapDataByFloorId, loadMap, type MapType, useAppDispatch, useAppSelector } from "@lib/store";

export type FloorMap = { status: "loading" } | { status: "failed" } | { status: "loaded"; mapData: MapData };

/** The floor's map from Redux in the shape the map library takes, loading it when it isn't there yet. */
export const useFloorMap = ({
  buildingId,
  floorId,
  type,
}: {
  buildingId: string;
  floorId: string;
  type: MapType;
}): FloorMap => {
  const dispatch = useAppDispatch();
  const cachedMap = useAppSelector(getMapDataByFloorId(buildingId, floorId, type));

  useEffect(
    function loadMapIfMissing() {
      if (cachedMap.status === "NotLoaded") dispatch(loadMap({ buildingId, floorId, type }));
    },
    [buildingId, cachedMap.status, dispatch, floorId, type],
  );

  if (cachedMap.status === "Failed") return { status: "failed" };
  if (cachedMap.status !== "Loaded") return { status: "loading" };

  if (cachedMap.type === "2d") return { status: "loaded", mapData: { type: "2d", map: cachedMap.svg } };

  return { status: "loaded", mapData: { type: "3d", map: cachedMap.featureCollection } };
};
